import { Plugin, PluginKey } from 'prosemirror-state'
import { Dispatch } from '@reduxjs/toolkit'
import { setActiveFeedbackCardId } from '@chegg-wt/core-wa/state/actions'

export const EDITOR_EVENTS_PLUGIN_KEY = 'editor-events'

export const editorEvents = (dispatch: Dispatch, disabled: boolean): Plugin => {
  const plugin = new Plugin({
    key: new PluginKey(EDITOR_EVENTS_PLUGIN_KEY),
    props: {
      handleClick(_view, _pos, event) {
        event.stopPropagation()

        // Don't expand matching card when loading (for disabling editor)
        if (disabled) return
        const { id } = event.target as HTMLElement
        if (id) {
          dispatch(setActiveFeedbackCardId(id))
        }
      },
    },
  })

  return plugin
}
